var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgShareOrRaudFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 9000 9000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.254574,1.2541,-1.23072,0.249826,10662.4,127.268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3678.5,4640C2359.7,4640 1289,5530.79 1289,6628C1289,7725.21 2359.7,8616 3678.5,8616C3282.86,8152.13 2961.65,7421.03 2961.65,6628C2961.65,5834.97 3282.86,5103.87 3678.5,4640Z",
    style: {
      fill: "rgb(230,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0051235,1.44954,-1.29365,-0.0045725,9933.39,-5963.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7034,1311L8996,3722L5072,3722L7034,1311Z",
    style: {
      fill: "rgb(230,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9528,0,0,0.98047,202.051,231.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4767,228.245L4767,2579.76M4756.51,5547.89C4756.51,6289.4 4770.15,6982.98 4770.15,7724.49M4772.45,231.732L8773.63,4012.21",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: 862
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.794338,0,0,0.996724,729.332,-317.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3220,
    y: 3029,
    width: 2447,
    height: 1495,
    style: {
      fill: "rgb(230,0,0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94999,0.0027,0.00262,0.97797,195.368,237.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8784.49,4009.22L4771.62,7744.13",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: "862.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9528,0,0,0.98047,202.051,231.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4750,2579C3599.74,2593.36 465.899,2576.29 248,8218",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: 862
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9527,0.01428,-0.01388,0.98037,385.58,127.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4642.92,5550.2C4421.86,5500.53 1868.78,5108.28 194.287,8308.65",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: "861.65px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOrRaudFilled);
export default __webpack_public_path__ + "static/media/share_or_raud_filled.f040619a91049079434d8179b17a1bb4.svg";
export { ForwardRef as ReactComponent };